import AppLoadPageMixin from "@/protected/mixins/AppLoadPageMixin";
import Editor from "./TagEditor";
import service from "./TagService";

export default {
  mixins: [AppLoadPageMixin],

  components: {
    Editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.label;
    }
  }
};
